import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/music/pisces.mp3'
import _imports_1 from '@/assets/music/cyclone.mp3'
import _imports_2 from '@/assets/music/ben.mp3'
import _imports_3 from '@/assets/music/junk.mp3'
import _imports_4 from '@/assets/music/lakeland.mp3'
import _imports_5 from '@/assets/music/record_player/turntable.png'
import _imports_6 from '@/assets/music/record_player/record.png'
import _imports_7 from '@/assets/music/record_player/needle.gif'
import _imports_8 from '@/assets/music/record_player/pin.png'


const _withScopeId = n => (_pushScopeId("data-v-2595f66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "music" }
const _hoisted_2 = { class: "music-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title-iso" }, "Streaming", -1))
const _hoisted_4 = { class: "link-tiles-container" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<hr data-v-2595f66c><div class=\"page-title-iso\" data-v-2595f66c>Snippets</div><div class=\"music-content\" data-v-2595f66c><div class=\"players\" data-v-2595f66c><div class=\"snippet-card\" data-v-2595f66c><div class=\"snippet-card-title\" data-v-2595f66c> pisces </div><audio controls class=\"audio\" data-v-2595f66c><source src=\"" + _imports_0 + "\" data-v-2595f66c></audio></div><div class=\"snippet-card\" data-v-2595f66c><div class=\"snippet-card-title\" data-v-2595f66c> cyclone </div><audio controls class=\"audio\" data-v-2595f66c><source src=\"" + _imports_1 + "\" data-v-2595f66c></audio></div><div class=\"snippet-card\" data-v-2595f66c><div class=\"snippet-card-title\" data-v-2595f66c> ben </div><audio controls class=\"audio\" data-v-2595f66c><source src=\"" + _imports_2 + "\" data-v-2595f66c></audio></div><div class=\"snippet-card\" data-v-2595f66c><div class=\"snippet-card-title\" data-v-2595f66c> junk </div><audio controls class=\"audio\" data-v-2595f66c><source src=\"" + _imports_3 + "\" data-v-2595f66c></audio></div><div class=\"snippet-card\" data-v-2595f66c><div class=\"snippet-card-title\" data-v-2595f66c> lakeland </div><audio controls class=\"audio\" data-v-2595f66c><source src=\"" + _imports_4 + "\" data-v-2595f66c></audio></div></div><div class=\"record-player\" data-v-2595f66c><img class=\"turntable\" src=\"" + _imports_5 + "\" data-v-2595f66c><img class=\"record spin\" src=\"" + _imports_6 + "\" data-v-2595f66c><img class=\"needle\" src=\"" + _imports_7 + "\" data-v-2595f66c><img class=\"pin\" src=\"" + _imports_8 + "\" data-v-2595f66c></div></div>", 3)

import LinkTileGrid from '@/components/LinkTileGrid.vue';
import LinkTileExternal from '@/components/LinkTileExternal.vue';
import linksExternalMusic from '@/assets/linksExternalMusic.json'

export default /*#__PURE__*/_defineComponent({
  __name: 'MusicView',
  setup(__props) {

// import { computed} from 'vue'
// const audioPlayers = computed(() => document.getElementsByClassName('audio'))
// const audioPlayersArray = computed(() => Array.prototype.slice.call(audioPlayers.value))
// const audioPlaying = computed(() => audioPlayersArray.value.find(x => !x.paused))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(LinkTileGrid, { cols: 6 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linksExternalMusic), (item, i) => {
              return (_openBlock(), _createBlock(LinkTileExternal, {
                key: `home-link-external-music-${i}`,
                data: item
              }, null, 8, ["data"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _hoisted_5
    ])
  ]))
}
}

})